<div *ngIf="welcome">    
    <p><strong>Employers, Verification Agencies & Consumers</strong></p>

    <p>You have the following options for verifying NBRC credentials. </p>
        <ol>
            <li>Call the NBRC at 913.895.4900 for oral verification of credentials by phone: <strong>free</strong>.  </li>
            <li>Look up and print verification of credentials after using the search button below to find the credentialed practitioner's 
                record (does not include credential earned date): <strong>free</strong>.
            </li>
            <li>Order an emailed credential verification after using the search button below to find the credentialed practitioner's record: <strong>$5</strong>. </li>
            <li>Instruct the credentialed practitioner to log in to their account to order an emailed 
                official credential letter: <strong>$5</strong>. 
            </li>
        </ol>
    
    <p><button (click)="welcome=false;" class="button button--alt">Search</button></p>

    <strong>Credential Holders</strong>
    <p>
        You can send a verification of your credential via the email option to your state board, employer or to anyone that requires primary source 
        verification - meaning the entity that is requesting the verification from you wants the verification to come from NBRC directly, rather from you. 
        State board email addresses are prepopulated on the order page. All state boards accept our email verification.</p>
    
    <p>Log in to your <a href="./">Practitioner Portal</a> account to order an emailed official credential letter. A fee of $5 is required.</p>

    <p>If you want a printed copy of your NBRC certificate, you can download a copy from your <a href={{getLoginPath()}}>Practitioner Portal</a> at any time.</p>

    <p><strong>Newly certified?</strong> If you are recently credentialed, you can send verification and access a copy of your NBRC certificate after your 
    <a href={{getLoginPath()}}>Practitioner Portal</a> account is updated, usually 24-48 hours after you pass the examination.</p>

        <P><strong>Request Verification Receipt</strong></P>
    <p>If you need a receipt for your past verification requests, we can send you a copy. Provide the email you made your request under, and we will email you all 
        the verification requests in our system from the past six months. </p>
    <p><button routerLink="/directory/purchase/receipt" class="button button--alt">Request receipt</button></p>
</div>
<div *ngIf="!welcome">
    <p>Credentialing information provided by the NBRC (electronic, verbal, written or otherwise) is considered primary source verification.</p>
    <p>You do not need to complete all the Advanced Search fields. We suggest using the minimum amount of information necessary as all fields you use must exactly match the data in our records. </p>
    <div class="col-wrap">
        <div class="col--secondary">
            <app-search-form [searchParams]="searchParams$"></app-search-form>
        </div>
        <div class="col--primary">
            <app-directory-list [hideAddress]="showAllPractitioners" [listInfo]="listInfo" (pageClick)="pageClicked($event)"></app-directory-list>
        </div>
    </div>
    <p> Credentials expire on the date indicated and will not be recognized as valid if this individual does not complete the
        Credential Maintenance Program requirements.</p> 
    <p>*Credentials earned prior to July 1, 2002 do not expire, are listed with a valid thru date of N/A, 
        and the individual is not required to participate in the Credential Maintenance Program.
    </p>
</div>